module.exports = __webpack_public_path__ + "static/media/contact-02.34763584.png";